import { Radio, Space, Typography } from 'antd';
import React from 'react';
import { shallowEqual } from 'react-redux';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import { justIntCapUpdated, justToPaymentDayUpdated, JUST_WITH_CAP, JUST_WO_CAP, JUST_WO_INT } from '../../../../store/justOpts';
import { PRINCIPAL_INTEREST } from '../../../../store/lawsuitOpts';
import { GRID_SM_PX, RowExt } from '../../../../styles';
import { useAppDispatch, useTypedSelector } from '../../../../store';
import { JustRadioButton } from '../../../../styles/ui';
import AnimOpacity from '../../../UI/Anim/AnimOpacity';


const JustIntCap = () => {
  const dispatch = useAppDispatch();
  const { justIntCap, justToPaymentDay } = useTypedSelector(state =>
    state.justOpts, shallowEqual);
  const { t } = useTranslation();
  const principalAmountOpt = useTypedSelector(state =>
    state.sumUp.lawsuitOpts.principalAmountOpt);

  const paymentsExist = useTypedSelector(state =>
    !_.isEmpty(state.sumUp.paymentData));

  if (principalAmountOpt !== PRINCIPAL_INTEREST){
    return (
      <>
        <RowExt marginTop="md">
          <Typography.Title level={4}>
            {t('justIntCap.title')}
          </Typography.Title>
        </RowExt>
        <RowExt marginTop="sm" align="middle">
          <Space>
            <Radio.Group
              value={justIntCap}
              size="middle"
              onChange={
           (event) => {
             dispatch(justIntCapUpdated(event.target.value));
           }
         }
            >
              <JustRadioButton value={JUST_WITH_CAP}>{t('Yes').toLocaleUpperCase()}</JustRadioButton>
              <JustRadioButton value={JUST_WO_CAP} disabled={paymentsExist}>{t('No').toLocaleUpperCase()}</JustRadioButton>
              <JustRadioButton value={JUST_WO_INT}>{t('justIntCap.wo').toLocaleUpperCase()}</JustRadioButton>
            </Radio.Group>
          </Space>
        </RowExt>
        {justIntCap === JUST_WO_CAP ? (
          <AnimOpacity>
            <RowExt align="middle" marginTop={24}>
              <RadioDescText>
                {t('justIntCap.period')}
              </RadioDescText>
              <Radio.Group
                value={justToPaymentDay}
                size="middle"
                onChange={
           (event) => {
             dispatch(justToPaymentDayUpdated(event.target.value));
           }
         }
              >
                <RadioButtonResp value={true}>
                  {t('justIntCap.paymentDate')}
                </RadioButtonResp>
                <RadioButtonResp value={false}>
                  {' '}
                  {t('justIntCap.endDate')}
                </RadioButtonResp>
              </Radio.Group>
            </RowExt>
          </AnimOpacity>
        )
          : null}
      </>
    );
  }
  return null;
};

export default JustIntCap;


export const RadioDescText = styled(Typography.Text)`
    margin: 0 12px;
    font-weight: 700;
    text-align: center;
`;

export const RadioButtonResp = styled(JustRadioButton)`
  @media only screen and (max-width: ${GRID_SM_PX}) {
      margin-top: 24px;
	}
`;